/* assets/custom.js */
(() => {
  // ---------- Helpers ----------
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const int = (v, d = 0) => {
    const n = parseInt(String(v), 10);
    return Number.isFinite(n) ? n : d;
  };

  const getQtyInput = (sectionId) =>
    document.getElementById(`Quantity-${sectionId}`) ||
    document.getElementById(`Quantity-${sectionId}-inline`) ||
    document.querySelector(`[data-section-id="${sectionId}"] input.quantity__input`);

  const getQtyValue = (input) => Math.max(1, int(input?.value, 1));

  const getInventoryEl = (sectionId) => document.getElementById(`Inventory-${sectionId}`);

  // Holt NUR ein bereits vorhandenes Ziel-DIV; erzeugt nichts.
  const ensureMsgEl = (sectionId) => document.getElementById(`DeliveryMessage-${sectionId}`);

  // Bestmögliche Quelle für die aktuelle Bestandszahl aus dem DOM
  const parseInventoryFromText = (sectionId) => {
    const scope = getInventoryEl(sectionId);
    const hidden = scope?.querySelector('[data-dlv="inv-source"]');
    const txt = (hidden?.innerText || scope?.innerText || '').trim();
    const m = txt.match(/\d+/);
    return m ? int(m[0], 0) : 0;
  };

  // ---------- Renderer ----------
  const renderMessage = (msgEl, qty, inventory) => {
    if (!msgEl) return;

    let textHtml = '';
    if (inventory > 0) {
      if (qty > inventory) {
        const diff = qty - inventory;
textHtml = `${inventory} Artikel: 2–3 Werktage<br><span style="color: orange;">${diff} Artikel: 10–14 Werktage</span>`;      } else {
        textHtml = `Lieferzeit: 2–3 Werktage`;
      }
    } else {
      // Falls das Container-DIV doch vorhanden ist und kein Lager
      textHtml = `Lieferzeit: 10–14 Werktage`;
    }

    msgEl.innerHTML = `${textHtml}`;
  };

  // Merker je Section (zuletzt bekannte Bestandszahl aus variant-change)
  const inventoryBySection = new Map();

  const recalc = (sectionId) => {
    // Nur arbeiten, wenn der Liquid-Zweig das Ziel-DIV gerendert hat
    const msgEl = ensureMsgEl(sectionId);
    if (!msgEl) return;

    const qtyInput = getQtyInput(sectionId);
    const qty = getQtyValue(qtyInput);

    const inv = inventoryBySection.has(sectionId)
      ? inventoryBySection.get(sectionId)
      : parseInventoryFromText(sectionId);

    renderMessage(msgEl, qty, inv);
  };

  // ---------- Events ----------
  // Variantenwechsel – Theme published "variant-change" (siehe global.js)
  document.addEventListener('variant-change', (e) => {
    const d = e.detail || {};
    const sectionId = d.sectionId;
    if (!sectionId) return;

    const inventory = int(d.variant?.inventory_quantity, null);
    if (inventory !== null) {
      inventoryBySection.set(sectionId, inventory);
    } else {
      inventoryBySection.delete(sectionId);
    }
    recalc(sectionId);
  });

  // Menge beobachten (input/change + Plus/Minus Buttons)
  const bindQtyListeners = (sectionId) => {
    const input = getQtyInput(sectionId);
    if (!input || input.__dlvBound) return;

    const update = () => recalc(sectionId);
    input.addEventListener('input', update, { passive: true });
    input.addEventListener('change', update, { passive: true });

    const wrap = input.closest('quantity-input');
    if (wrap) {
      const inc = wrap.querySelector('.quantity__button-increase, .quantity__button[name="plus"]');
      const dec = wrap.querySelector('.quantity__button-decrease, .quantity__button[name="minus"]');
      [inc, dec].forEach((btn) => {
        btn && btn.addEventListener('click', () => requestAnimationFrame(update), { passive: true });
      });
    }
    input.__dlvBound = true;
  };

  // ---------- Bootstrapping ----------
  const initSection = (sectionId) => {
    bindQtyListeners(sectionId);
    recalc(sectionId);
  };

  const initAll = () => {
    $$('[id^="Inventory-"]').forEach((invEl) => {
      const sectionId = invEl.id.replace('Inventory-', '');
      initSection(sectionId);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Wenn Shopify die Section neu rendert
  document.addEventListener('shopify:section:load', (ev) => {
    const sectionId = String(ev?.detail?.sectionId || '');
    if (sectionId) initSection(sectionId);
  });
})();
